module.exports = girder_plugin_large_image;


//////////////////
// WEBPACK FOOTER
// external "girder_plugin_large_image"
// module id = 17
// module chunks = 0